import React from "react";
import { Route, Switch, Redirect } from "react-router";
import PropTypes from "prop-types";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import isAuthenticated from "./isAuthenticated";
import * as urls from "./contants/urls";
import Login from "../containers/Auth/Login";
import Home from "../containers/Home";
import DashBoardTalents from "../containers/Modules/Talents/DashBoardTalents";
import DashBoardPlug from "../containers/Modules/Plug/DashBoardPlug";
import DashBoardManager from "../containers/Modules/Manager/DashBoardManager";
import ChangePassword from "../containers/Auth/ChangePassword";
import SignatureRemote from "../components/Signature/SignatureRemote";

export const history = createBrowserHistory();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
    }
  />
);

const Routes = props => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route exact path="/" component={Login} />
      <Route exact path={`/Signature/:token?`} component={SignatureRemote} />
      <PrivateRoute exact path={urls.APP} component={Home} />
      <PrivateRoute path={urls.TALENTS_AEC} component={DashBoardTalents} />
      <PrivateRoute exact path={urls.NEW_PASSWORD} component={ChangePassword} />
      <PrivateRoute path={urls.PLUG_AEC} component={DashBoardPlug} />
      <PrivateRoute path={urls.MANAGER_AEC} component={DashBoardManager} />
    </Switch>
  </ConnectedRouter>
);

PrivateRoute.propTypes = {
  component: PropTypes.func,
  location: PropTypes.string,
  history: PropTypes.object
};

PrivateRoute.defaultProps = {
  component: PropTypes.func,
  history: PropTypes.object
};

export default Routes;
